module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/txt-closed@3x-e8101fa5ec38ad412dac0f729cea4296.png";